import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["dropdown", "button"]

    initialize() {
        this.buttonTarget.addEventListener('focus', this.showDropdown.bind(this));
        this.buttonTarget.addEventListener('focusout', this.hideDropdown.bind(this));
        
        this.dropdownTarget.querySelectorAll('a').forEach(element => {
            element.addEventListener('focusout', this.hideDropdown.bind(this));
        });
        
        this.buttonTarget.addEventListener('mouseenter', this.showDropdown.bind(this));
        this.element.addEventListener('mouseleave', this.hideDropdown.bind(this));
        
        this.navigationElement = document.querySelector('[data-controller="navigation"]');
    }

    showDropdown() {
        this.dropdownTarget.classList.remove('invisible');
        this.dropdownTarget.classList.remove('opacity-0');
        this.buttonTarget.setAttribute('aria-expanded', 'true');
        
        if (this.navigationElement) {
            const navigationController = this.application.getControllerForElementAndIdentifier(
                this.navigationElement,
                "navigation"
            );
            if (navigationController && navigationController.ensureHeaderZIndex) {
                navigationController.ensureHeaderZIndex();
            }
        }
    }

    hideDropdown() {
        setTimeout(() => {
            if (this.dropdownTarget.contains(document.activeElement)) {
                return;
            }
            
            this.dropdownTarget.classList.add('invisible');
            this.dropdownTarget.classList.add('opacity-0');
            this.buttonTarget.setAttribute('aria-expanded', 'false');
            
            if (this.navigationElement) {
                const navigationController = this.application.getControllerForElementAndIdentifier(
                    this.navigationElement,
                    "navigation"
                );
                if (navigationController && navigationController.resetHeaderZIndex) {
                    const anyOtherDropdownVisible = document.querySelector('[data-dropdown-target="dropdown"]:not(.invisible):not(.opacity-0)');
                    if (!anyOtherDropdownVisible) {
                        navigationController.resetHeaderZIndex();
                    }
                }
            }
        }, 150) 
    }

    handleKeydown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const isVisible = !this.dropdownTarget.classList.contains('invisible');
            if (isVisible) {
                this.hideDropdown();
            } else {
                this.showDropdown();
            }
        }
    }
}